import ObjectID from "bson-objectid";

export function isValidLanguage(language: any) {
    return language === null || (typeof language === "string") && language.length < 5;
}

export function isValidAlphanumericStringNoSpecialChar(text: string) {
    if(text === null) {
        return false;
    }

    const regex = /^\b[A-Za-z0-9]+\b$/;
    return text.match(regex) !== null; // TODO: check
}

export function isValidEmail(email: string) {
    if(email === null) {
        return false;
    }

    const regex = /^\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b$/;
    return email.match(regex) !== null; // TODO: check
}

/**
 * Returns true when given value is not undefined and not null.
 * @param value
 */
export function isDefined(value: any): boolean {
    return value !== undefined && value !== null;
}

export function isValidId(id: any) {
    return ObjectID.isValid(id);
}

export function isValidBoolean(value: any): boolean {
    return typeof(value) === "boolean";
}

export function toBoolean(value: string): boolean {
    if(value === "false") {
        return false;
    }
    return Boolean(value);
}

export function toNumber(value: string | number): number {
    if(typeof(value) === "string") {
        return Number(value.replace(",", "."));
    } else {
        return Number(value);
    }
}

export function isValidNumber(value: any): boolean {
    return !isNaN(value);
}

export function isValidInteger(value: any): boolean {
    return Number.isInteger(value);
}

export function isValidPositiveInteger(value: any): boolean {
    return Number.isInteger(value) && value >= 0;
}

export function isValidStrictlyPositiveInteger(value: any): boolean {
    return Number.isInteger(value) && value > 0;
}

export function isValidPositiveFloatingPoint(value: any): boolean {
    return isValidNumber(value) && value >= 0;
}

export function isValidStrictlyPositiveFloatingPoint(value: any): boolean {
    return isValidNumber(value) && value > 0;
}

export function fuzzyEquals(first: number, second: number, DELTA: number = 0.0001): boolean {
    if(first === second) {
        return true;
    }
    if(first < second + DELTA && first > second - DELTA) {
        return true;
    }
    return false;
}

/**
 * Runs function f with value as parameter If (value is) Not Undefined
 * @param value
 * @param f
 */
export function inu<T, U, V>(value: T | undefined, f: (v: T) => U, g?: () => V): U | V | null {
    if(value !== undefined) {
        return f(value);
    } else if(g !== undefined) {
        return g();
    } else {
        return null;
    }
}

/**
 * Runs function f with value as parameter If (value is) Not Undefined and not null
 * @param value
 * @param f
 */
export function inun<T, U, V>(value: T | undefined | null, f: (v: T) => U, g?: () => V): U | V | null {
    if(value !== undefined && value !== null) {
        return f(value);
    } else if(g !== undefined) {
        return g();
    } else {
        return null;
    }
}

/**
 * Runs function f with value as parameter If (value is) not null
 * @param value
 * @param f
 */
export function inn<T, U, V>(value: T | null, f: (v: T) => U, g?: () => V): U | V | null {
    if (value !== null) {
        return f(value);
    } else if(g !== undefined) {
        return g();
    } else {
        return null;
    }
}
